var faq =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(96);
	__webpack_require__(93);
	__webpack_require__(154);
	__webpack_require__(533);

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(50);
	
	jQuery(function () {
	    module.exports.params = {
	        infinite: true,
	        adaptiveHeight: true,
	        slidesToScroll: 1,
	        speed: 400
	    };
	
	    module.exports.paramsCssAnim = {
	        cssEase: 'ease',
	        useTransform: true,
	        speed: 600
	    };
	});

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$defineProperties = __webpack_require__(56)['default'];
	
	module.exports = _Object$defineProperties({}, {
	    defaultFontSize: {
	        get: function get() {
	            var defaultFontSize = parseInt($('html').css('font-size'));
	            if (isNaN(defaultFontSize)) defaultFontSize = 16;
	            return defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobile: {
	        get: function get() {
	            return 20 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobileBig: {
	        get: function get() {
	            return 28 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tablet: {
	        get: function get() {
	            return 48 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tabletBig: {
	        get: function get() {
	            return 60 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    desktop: {
	        get: function get() {
	            return 76.5 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    }
	});

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(57), __esModule: true };

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(58);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperties: __webpack_require__(75) });


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var ctx = __webpack_require__(62);
	var hide = __webpack_require__(64);
	var has = __webpack_require__(74);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(69) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(68);
	var toPrimitive = __webpack_require__(72);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(69) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(69) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	var document = __webpack_require__(60).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(67);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var anObject = __webpack_require__(66);
	var getKeys = __webpack_require__(76);
	
	module.exports = __webpack_require__(69) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(77);
	var enumBugKeys = __webpack_require__(90);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(74);
	var toIObject = __webpack_require__(78);
	var arrayIndexOf = __webpack_require__(82)(false);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(80);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(78);
	var toLength = __webpack_require__(83);
	var toAbsoluteIndex = __webpack_require__(85);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(84);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),

/***/ 84:
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(88) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	__webpack_require__(94);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-slick-reviews').each(function () {
	        var $reviewsSlider = $(this);
	
	        $reviewsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 3,
	            adaptiveHeight: false,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: {
	                    slidesToShow: 2
	                }
	            }, {
	                breakpoint: size.tablet,
	                settings: {
	                    slidesToShow: 1
	                }
	            }]
	        }));
	    });
	});

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(112);

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(113);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperty: __webpack_require__(65).f });


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(117);

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	module.exports = $;

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(133);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(135);
	module.exports = __webpack_require__(61).Object.assign;


/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(59);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(136) });


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(69);
	var getKeys = __webpack_require__(76);
	var gOPS = __webpack_require__(137);
	var pIE = __webpack_require__(138);
	var toObject = __webpack_require__(139);
	var IObject = __webpack_require__(79);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(70)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _gtm = __webpack_require__(141);
	
	var _gtm2 = _interopRequireDefault(_gtm);
	
	var _fbpixel = __webpack_require__(142);
	
	var _fbpixel2 = _interopRequireDefault(_fbpixel);
	
	var _mailru = __webpack_require__(143);
	
	var _yandexMetrika = __webpack_require__(144);
	
	//import { MindboxTracker } from '../../modules/mindbox/mindbox-tracker';
	
	__webpack_require__(145);
	__webpack_require__(146);
	
	var Trackers = (function () {
	    function Trackers() {
	        var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        _classCallCheck(this, Trackers);
	
	        this.data = arg;
	        this.yandexMetrika = new _yandexMetrika.YandexMetrika();
	        this.instances = {
	            gtm: new _gtm2['default'](),
	            fbpixel: new _fbpixel2['default']()
	        };
	        if (!arg.onlyTrackers) {
	            return;
	        }
	
	        for (var track in this.instances) {
	            if (arg.onlyTrackers.indexOf(track) === -1 && this.instances.hasOwnProperty(track)) {
	                delete this.instances[track];
	            }
	        }
	    }
	
	    _createClass(Trackers, [{
	        key: 'backendPageViewed',
	        value: function backendPageViewed() {
	            this.mailru = new _mailru.MailRuTracker();
	            var route = $('.main-container').data('route');
	
	            switch (route) {
	                case 'index':
	                    this.indexPageViewed();
	                    break;
	                case 'catalog.section':
	                    this.categoryPageViewed();
	                    break;
	                case 'catalog.product':
	                    this.productPageViewed();
	                    break;
	                case 'cart':
	                    this.basketPageViewed();
	                    break;
	                case 'order':
	                    this.orderPageViewed();
	                    break;
	                case 'search':
	                    this.searchPageViewed();
	                    break;
	                default:
	                    this.otherPageViewed();
	                    break;
	            }
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            this.yandexMetrika.userAuthorized(user);
	        }
	    }, {
	        key: 'clientTimeSite',
	        value: function clientTimeSite() {
	            var time = arguments.length <= 0 || arguments[0] === undefined ? 190000 : arguments[0];
	
	            var _self = this;
	            setTimeout(function () {
	                _self.yandexMetrika.timeClient();
	            }, time);
	        }
	    }, {
	        key: 'trigger',
	        value: function trigger(evType, arg) {
	            for (var instName in this.instances) {
	                if (typeof this.instances[instName][evType] === 'function' && this.instances.hasOwnProperty(instName)) {
	                    this.instances[instName][evType](arg[instName]);
	                }
	            }
	        }
	    }, {
	        key: 'getTracker',
	        value: function getTracker(tracker) {
	            return this.instances[tracker];
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToCart', arg);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAddToFav', arg);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSearch', arg);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onContentView', arg);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUp', arg);
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSignUpEnd', arg);
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutStart', arg);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCheckoutEnd', arg);
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserWindow', arg);
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onAdviserReply', arg);
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('claimButton', arg);
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onTabClick', arg);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscribe', arg);
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onSubscriptionDone', arg);
	            this.trigger('onPMfrmSubscribe', arg);
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackFormShow', arg);
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackButton', arg);
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onCallBackRequestSend', arg);
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onBasketRefresh', arg);
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyButton', arg);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('onOneClickBuyEnd', arg);
	        }
	    }, {
	        key: 'onPMbtnTel',
	        value: function onPMbtnTel() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnTel', arg);
	        }
	    }, {
	        key: 'onPMbtnFilter',
	        value: function onPMbtnFilter() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFilter', arg);
	        }
	    }, {
	        key: 'onClickEvent',
	        value: function onClickEvent() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onClickPdf',
	        value: function onClickPdf() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger(arg.event, { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFavorite',
	        value: function onPMbtnFavorite() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFavorite', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtnAddToCart',
	        value: function onPMbtnAddToCart() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAddToCart', { gtm: { param1: arg.param } });
	        }
	    }, {
	        key: 'onPMbtn1Click',
	        value: function onPMbtn1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtn1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMfrm1Click',
	        value: function onPMfrm1Click() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrm1Click', { gtm: { param1: arg.param1, param2: arg.param2 } });
	        }
	    }, {
	        key: 'onPMbtnFAQ',
	        value: function onPMbtnFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnFAQ', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMeContact',
	        value: function onPMfrmCallMeContact() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMeContact', arg);
	        }
	    }, {
	        key: 'onPMfrmFAQ',
	        value: function onPMfrmFAQ() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmFAQ', arg);
	        }
	    }, {
	        key: 'onPMbtnCallMe',
	        value: function onPMbtnCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmCallMe',
	        value: function onPMfrmCallMe() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmCallMe', arg);
	        }
	    }, {
	        key: 'onPMfrmReg',
	        value: function onPMfrmReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmReg', arg);
	        }
	    }, {
	        key: 'onPMbtnReg',
	        value: function onPMbtnReg() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnReg', arg);
	        }
	    }, {
	        key: 'onPMbtnComment',
	        value: function onPMbtnComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnComment', arg);
	        }
	    }, {
	        key: 'onPMfrmComment',
	        value: function onPMfrmComment() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmComment', arg);
	        }
	    }, {
	        key: 'onPMbtnAskQuestion',
	        value: function onPMbtnAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMbtnAskQuestion', arg);
	        }
	    }, {
	        key: 'onPMfrmAskQuestion',
	        value: function onPMfrmAskQuestion() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('PMfrmAskQuestion', arg);
	        }
	    }, {
	        key: 'onClickPromo',
	        value: function onClickPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onViewPromo',
	        value: function onViewPromo() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommercePromoView', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowNewProducts',
	        value: function onShowNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowWatchedProducts',
	        value: function onShowWatchedProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowAnalogProducts',
	        value: function onShowAnalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAddProduct',
	        value: function onClickAddProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickRemoveProduct',
	        value: function onClickRemoveProduct() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceRemove', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderCartStep1',
	        value: function onShowOrderCartStep1() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowOrderStep',
	        value: function onShowOrderStep() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceCheckout', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowcatalogProducts',
	        value: function onShowcatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceImpressions', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickCatalogProducts',
	        value: function onClickCatalogProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickWatched',
	        value: function onClickWatched() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickAnalog',
	        value: function onClickAnalog() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onClickNewProducts',
	        value: function onClickNewProducts() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceClick', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCard',
	        value: function onShowProductCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'onShowProductCardPopup',
	        value: function onShowProductCardPopup() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceDetail', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromCard',
	        value: function addToCardFromCard() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'addToCardFromList',
	        value: function addToCardFromList() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('ecommerceAdd', { gtm: { ecommerce: arg } });
	        }
	    }, {
	        key: 'completeRegistration',
	        value: function completeRegistration() {
	            var arg = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	            this.trigger('CompleteRegistration', arg);
	        }
	    }, {
	        key: 'indexPageViewed',
	        value: function indexPageViewed() {
	            this.mailru.indexPageView();
	        }
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            this.mailru.categoryPageView();
	            //this.mindboxTracker.categoryView(this.data.category);
	        }
	    }, {
	        key: 'productPageViewed',
	        value: function productPageViewed() {
	            this.mailru.productPageView($('.product-detail__action-btn').data('product-id'), $('.product-detail__price-sum').data('price'));
	            //this.mindboxTracker.productView($('.js-vendor-code').data('vendor-code'));
	        }
	    }, {
	        key: 'otherPageViewed',
	        value: function otherPageViewed() {
	            this.mailru.otherPageView();
	        }
	    }, {
	        key: 'searchPageViewed',
	        value: function searchPageViewed() {
	            this.mailru.searchPageView();
	        }
	    }, {
	        key: 'orderPageViewed',
	        value: function orderPageViewed() {
	            this.mailru.orderPageView();
	        }
	    }, {
	        key: 'basketPageViewed',
	        value: function basketPageViewed() {
	            var ids = [];
	            var products = document.querySelectorAll('.cart__item .cart__item-content');
	            products.forEach(function (product) {
	                ids.push(product.getAttribute('data-product-id'));
	            });
	
	            this.mailru.basketPageView(ids, $('.basket-final-price').html());
	        }
	    }]);
	
	    return Trackers;
	})();
	
	exports['default'] = Trackers;
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var GTMEvents = (function () {
	    function GTMEvents() {
	        _classCallCheck(this, GTMEvents);
	
	        this.events = {
	            registrationDone: 'Registration_Done',
	            subscriptionButton: 'Subscription_Button',
	            subscriptionDone: 'Subscription_Done',
	            PMfrmSubscribe: 'PMfrmSubscribe',
	            add2CartButton: 'Add2Cart_Button',
	            oneClickBuyButton: 'oneClick_buy_Button',
	            accessoriesTab: 'accessories_tab',
	            faqTab: 'faq_tab',
	            reviewsTab: 'reviews_tab',
	            descriptionTab: 'description_tab',
	            onlineConsultant: 'online_consultant',
	            onlineConsultantButton: 'online_consultant_button',
	            onlineConsultantSent: 'online_consultant_sent',
	            backcall: 'backcall',
	            backcallButton: 'backcall_button',
	            backcallSent: 'backcall_sent',
	            claimButton: 'claim_button',
	            claimDone: 'claim_Done',
	            basketRefresh: 'basket_refresh',
	            basketOrder: 'basket_order',
	            contactLogin: 'contact_login',
	            contact1clickBuy: 'contact_1clickBuy',
	            contactRegistration: 'contact_registration',
	            contactRegistrationContinue: 'contact_registration_continue',
	            contactLoginContinue: 'contact_login_continue',
	            contact1clickBuyContinue: 'contact_1clickBuy_continue',
	            confirmOrder: 'confirm_order',
	            PMbtnSocial: 'PMbtnSocial',
	            PMbtnFAQ: 'PMbtnFAQ',
	            PMfrmFAQ: 'PMfrmFAQ',
	            PMbtnCallMe: 'PMbtnCallMe',
	            PMfrmCallMe: 'PMfrmCallMe',
	            PMbtnReg: 'PMbtnReg',
	            PMfrmReg: 'PMfrmReg',
	            PMbtnSelectCity: 'PMbtnSelectCity',
	            PMbtnTellAbout: 'PMbtnTellAbout',
	            PMbtnContact: 'PMbtnContact',
	            PMbtnComment: 'PMbtnComment',
	            PMfrmComment: 'PMfrmComment',
	            PMbtnAskQuestion: 'PMbtnAskQuestion',
	            PMfrmAskQuestion: 'PMfrmAskQuestion',
	            PMbtn1Click: 'PMbtn1Click',
	            PMfrm1Click: 'PMfrm1Click',
	            PMbtnFavorite: 'PMbtnFavorite',
	            PMbtnAddToCart: 'PMbtnAddToCart',
	            PMbtnTabs: 'PMbtnTabs',
	            PMbtnTel: 'PMbtnTel',
	            PMfrmCallMeContact: 'PMfrmCallMeContact',
	            PMbtnVariant: 'PMbtnVariant',
	            PMbtnFilter: 'PMbtnFilter',
	            ecommercePromoClick: 'ecommercePromoClick',
	            ecommercePromoView: 'ecommercePromoView',
	            ecommerceImpressions: 'ecommerceImpressions',
	            ecommerceClick: 'ecommerceClick',
	            ecommerceDetail: 'ecommerceDetail',
	            ecommerceAdd: 'ecommerceAdd',
	            ecommerceRemove: 'ecommerceRemove',
	            ecommerceCheckout: 'ecommerceCheckout',
	            completeRegistration: 'CompleteRegistration'
	        };
	    }
	
	    _createClass(GTMEvents, [{
	        key: 'onAddToCart',
	        value: function onAddToCart(arg) {
	            if (arg) {
	                this.push(_extends({
	                    event: 'addToCart'
	                }, arg));
	                return;
	            }
	            this.pushEvent('add2CartButton');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd(event) {
	            this.pushEvent(event);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd() {
	            this.pushEvent('confirmOrder');
	        }
	    }, {
	        key: 'onAdviserWindow',
	        value: function onAdviserWindow() {
	            this.pushEvent('onlineConsultant');
	        }
	    }, {
	        key: 'onAdviserReply',
	        value: function onAdviserReply() {
	            this.pushEvent('onlineConsultantButton');
	        }
	    }, {
	        key: 'onFeedbackSend',
	        value: function onFeedbackSend() {
	            this.pushEvent('claimButton');
	        }
	    }, {
	        key: 'onTabClick',
	        value: function onTabClick(tab) {
	            var tabMap = {
	                descr: 'descriptionTab',
	                reviews: 'reviewsTab',
	                faq: 'faqTab',
	                login: 'contactLogin',
	                reg: 'contactRegistration',
	                oneclick: 'contact1clickBuy'
	            };
	
	            if (!tabMap[tab]) {
	                return;
	            }
	
	            this.pushEvent(tabMap[tab]);
	        }
	    }, {
	        key: 'onSubscribe',
	        value: function onSubscribe() {
	            this.pushEvent('subscriptionButton');
	        }
	    }, {
	        key: 'onSubscriptionDone',
	        value: function onSubscriptionDone() {
	            this.pushEvent('subscriptionDone');
	        }
	    }, {
	        key: 'onPMfrmSubscribe',
	        value: function onPMfrmSubscribe() {
	            this.pushEvent('PMfrmSubscribe');
	        }
	    }, {
	        key: 'PMbtnTel',
	        value: function PMbtnTel() {
	            this.pushEvent('PMbtnTel');
	        }
	    }, {
	        key: 'onCallBackFormShow',
	        value: function onCallBackFormShow() {
	            this.pushEvent('backcall');
	        }
	    }, {
	        key: 'onCallBackButton',
	        value: function onCallBackButton() {
	            this.pushEvent('backcallButton');
	        }
	    }, {
	        key: 'onCallBackRequestSend',
	        value: function onCallBackRequestSend() {
	            this.pushEvent('backcallSent');
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart() {
	            this.pushEvent('basketOrder');
	        }
	    }, {
	        key: 'onBasketRefresh',
	        value: function onBasketRefresh() {
	            this.pushEvent('basketRefresh');
	        }
	    }, {
	        key: 'onOneClickBuyButton',
	        value: function onOneClickBuyButton() {
	            this.pushEvent('oneClickBuyButton');
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd() {
	            this.pushEvent('contact1clickBuyContinue');
	        }
	    }, {
	        key: 'PMbtnSocial',
	        value: function PMbtnSocial(arg) {
	            this.push(_extends({
	                event: 'PMbtnSocial'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnVariant',
	        value: function PMbtnVariant(arg) {
	            this.push(_extends({
	                event: 'PMbtnVariant'
	            }, arg));
	        }
	    }, {
	        key: 'PMfrmCallMeContact',
	        value: function PMfrmCallMeContact(arg) {
	            this.push(_extends({
	                event: 'PMfrmCallMeContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTabs',
	        value: function PMbtnTabs(arg) {
	            this.push(_extends({
	                event: 'PMbtnTabs'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnAddToCart',
	        value: function PMbtnAddToCart(arg) {
	            this.push(_extends({
	                event: 'PMbtnAddToCart'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnSelectCity',
	        value: function PMbtnSelectCity(arg) {
	            this.push(_extends({
	                event: 'PMbtnSelectCity'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnTellAbout',
	        value: function PMbtnTellAbout(arg) {
	            this.push(_extends({
	                event: 'PMbtnTellAbout'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtn1Click',
	        value: function PMbtn1Click() {
	            this.push({
	                event: 'PMbtn1Click'
	            });
	        }
	    }, {
	        key: 'PMfrm1Click',
	        value: function PMfrm1Click(arg) {
	            this.push(_extends({
	                event: 'PMfrm1Click'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFavorite',
	        value: function PMbtnFavorite(arg) {
	            this.push(_extends({
	                event: 'PMbtnFavorite'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnContact',
	        value: function PMbtnContact(arg) {
	            this.push(_extends({
	                event: 'PMbtnContact'
	            }, arg));
	        }
	    }, {
	        key: 'PMbtnFAQ',
	        value: function PMbtnFAQ() {
	            this.push({
	                event: 'PMbtnFAQ'
	            });
	        }
	    }, {
	        key: 'PMfrmFAQ',
	        value: function PMfrmFAQ() {
	            this.push({
	                event: 'PMfrmFAQ'
	            });
	        }
	    }, {
	        key: 'PMbtnCallMe',
	        value: function PMbtnCallMe() {
	            this.push({
	                event: 'PMbtnCallMe'
	            });
	        }
	    }, {
	        key: 'PMfrmCallMe',
	        value: function PMfrmCallMe() {
	            this.push({
	                event: 'PMfrmCallMe'
	            });
	        }
	    }, {
	        key: 'PMbtnFilter',
	        value: function PMbtnFilter() {
	            this.push({
	                event: 'PMbtnFilter'
	            });
	        }
	    }, {
	        key: 'PMbtnReg',
	        value: function PMbtnReg() {
	            this.push({
	                event: 'PMbtnReg'
	            });
	        }
	    }, {
	        key: 'PMfrmReg',
	        value: function PMfrmReg() {
	            this.push({
	                event: 'PMfrmReg'
	            });
	        }
	    }, {
	        key: 'PMbtnComment',
	        value: function PMbtnComment() {
	            this.push({
	                event: 'PMbtnComment'
	            });
	        }
	    }, {
	        key: 'PMfrmComment',
	        value: function PMfrmComment() {
	            this.push({
	                event: 'PMfrmComment'
	            });
	        }
	    }, {
	        key: 'PMbtnAskQuestion',
	        value: function PMbtnAskQuestion() {
	            this.push({
	                event: 'PMbtnAskQuestion'
	            });
	        }
	    }, {
	        key: 'PMfrmAskQuestion',
	        value: function PMfrmAskQuestion() {
	            this.push({
	                event: 'PMfrmAskQuestion'
	            });
	        }
	    }, {
	        key: 'pushEvent',
	        value: function pushEvent(eventName) {
	            if (this.events[eventName] !== undefined) {
	                this.push({
	                    event: this.events[eventName]
	                });
	            }
	        }
	    }, {
	        key: 'ecommercePromoClick',
	        value: function ecommercePromoClick(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommercePromoView',
	        value: function ecommercePromoView(arg) {
	            this.push(_extends({
	                event: 'ecommercePromoView'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceImpressions',
	        value: function ecommerceImpressions(arg) {
	            this.push(_extends({
	                event: 'ecommerceImpressions'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceClick',
	        value: function ecommerceClick(arg) {
	            this.push(_extends({
	                event: 'ecommerceClick'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceDetail',
	        value: function ecommerceDetail(arg) {
	            this.push(_extends({
	                event: 'ecommerceDetail'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceAdd',
	        value: function ecommerceAdd(arg) {
	            this.push(_extends({
	                event: 'ecommerceAdd'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceRemove',
	        value: function ecommerceRemove(arg) {
	            this.push(_extends({
	                event: 'ecommerceRemove'
	            }, arg));
	        }
	    }, {
	        key: 'ecommerceCheckout',
	        value: function ecommerceCheckout(arg) {
	            this.push(_extends({
	                event: 'ecommerceCheckout'
	            }, arg));
	        }
	    }, {
	        key: 'push',
	        value: function push(params) {
	            window.dataLayer.push(params);
	        }
	    }]);
	
	    return GTMEvents;
	})();
	
	exports['default'] = GTMEvents;
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _extends = __webpack_require__(132)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var FBPixel = (function () {
	    function FBPixel() {
	        _classCallCheck(this, FBPixel);
	
	        var pageTitle = document.querySelector('h1');
	        this.title = pageTitle ? pageTitle.textContent : '';
	    }
	
	    _createClass(FBPixel, [{
	        key: 'track',
	        value: function track(type, args) {
	            if (typeof window.fbq !== 'function') {
	                return;
	            }
	            window.fbq('track', type, args);
	        }
	    }, {
	        key: 'onContentView',
	        value: function onContentView(location) {
	            var locations = ['categories', 'product', 'articles'];
	
	            if (locations.indexOf(location) === -1) {
	                return;
	            }
	
	            this.track('ViewContent', {
	                content_name: this.title
	            });
	        }
	    }, {
	        key: 'onCheckoutStart',
	        value: function onCheckoutStart(args) {
	            this.withCurrency('InitiateCheckout', args);
	        }
	    }, {
	        key: 'onCheckoutEnd',
	        value: function onCheckoutEnd(args) {
	            this.withCurrency('Purchase', args);
	        }
	    }, {
	        key: 'onOneClickBuyEnd',
	        value: function onOneClickBuyEnd(args) {
	            this.onCheckoutEnd(args);
	        }
	    }, {
	        key: 'onSearch',
	        value: function onSearch(args) {
	            this.track('Search', args);
	        }
	    }, {
	        key: 'onSignUp',
	        value: function onSignUp() {
	            this.track('Lead');
	        }
	    }, {
	        key: 'onSignUpEnd',
	        value: function onSignUpEnd() {
	            this.withCurrency('CompleteRegistration', {
	                value: 100
	            });
	        }
	    }, {
	        key: 'onAddToCart',
	        value: function onAddToCart(args) {
	            this.withCurrency('AddToCart', args);
	        }
	    }, {
	        key: 'onAddToFav',
	        value: function onAddToFav(args) {
	            this.withCurrency('AddToWishlist', _extends({}, args, {
	                content_name: this.title
	            }));
	        }
	    }, {
	        key: 'withCurrency',
	        value: function withCurrency(type) {
	            var args = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	            this.track(type, _extends({}, args, {
	                currency: 'RUB'
	            }));
	        }
	    }]);
	
	    return FBPixel;
	})();
	
	exports['default'] = FBPixel;
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	var _Object$assign = __webpack_require__(133)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var MailRuTracker = (function () {
	    function MailRuTracker() {
	        _classCallCheck(this, MailRuTracker);
	
	        this.init();
	    }
	
	    _createClass(MailRuTracker, [{
	        key: 'init',
	        value: function init() {
	            window._tmr = window._tmr || [];
	            return window._tmr;
	        }
	    }, {
	        key: 'push',
	        value: function push(query) {
	            window._tmr.push(query);
	        }
	    }, {
	        key: 'indexPageView',
	        value: function indexPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), { pagetype: 'home' }));
	        }
	    }, {
	        key: 'otherPageView',
	        value: function otherPageView() {
	            this.push(this.getQueryTemplate());
	        }
	    }, {
	        key: 'categoryPageView',
	        value: function categoryPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'category',
	                productid: '',
	                totalvalue: ''
	            }));
	        }
	    }, {
	        key: 'basketPageView',
	        value: function basketPageView(ids, totalPrice) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'cart',
	                productid: ids,
	                totalvalue: totalPrice
	            }));
	        }
	    }, {
	        key: 'productPageView',
	        value: function productPageView(id, price) {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'product',
	                productid: id,
	                totalvalue: parseFloat(price)
	            }));
	        }
	    }, {
	        key: 'orderPageView',
	        value: function orderPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'purchase'
	            }));
	        }
	    }, {
	        key: 'searchPageView',
	        value: function searchPageView() {
	            this.push(_Object$assign(this.getQueryTemplate(), {
	                pagetype: 'searchresults'
	            }));
	        }
	    }, {
	        key: 'getQueryTemplate',
	        value: function getQueryTemplate() {
	            return {
	                id: '3241057',
	                type: 'itemView',
	                productid: '',
	                pagetype: 'other',
	                totalvalue: '',
	                list: '3'
	            };
	        }
	    }]);
	
	    return MailRuTracker;
	})();

	exports.MailRuTracker = MailRuTracker;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var YandexMetrika = (function () {
	    function YandexMetrika() {
	        _classCallCheck(this, YandexMetrika);
	    }
	
	    _createClass(YandexMetrika, [{
	        key: 'track',
	        value: function track(code, eventCode) {
	            try {
	                window.ym(911516, code, eventCode);
	            } catch (e) {
	                //console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack);
	            }
	        }
	    }, {
	        key: 'timeClient',
	        value: function timeClient() {
	            this.track('reachGoal', 'time_more_than_x');
	        }
	    }, {
	        key: 'orderComplete',
	        value: function orderComplete() {
	            this.track('reachGoal', 'order_complete');
	        }
	    }, {
	        key: 'notFountPage',
	        value: function notFountPage() {
	            this.track('reachGoal', 'mn_error_404');
	        }
	    }, {
	        key: 'userAuthorized',
	        value: function userAuthorized(user) {
	            var userParams = { userId: user.USER_ID };
	            this.track('userParams', userParams);
	            this.track('params', userParams);
	            this.track('setUserID', user.USER_ID);
	        }
	    }]);
	
	    return YandexMetrika;
	})();

	exports.YandexMetrika = YandexMetrika;

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

	/*!
	Waypoints - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	/*!
	Waypoints Inview Shortcut - 4.0.1
	Copyright © 2011-2016 Caleb Troughton
	Licensed under the MIT license.
	https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
	*/
	(function() {
	  'use strict'
	
	  function noop() {}
	
	  var Waypoint = window.Waypoint
	
	  /* http://imakewebthings.com/waypoints/shortcuts/inview */
	  function Inview(options) {
	    this.options = Waypoint.Adapter.extend({}, Inview.defaults, options)
	    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
	    this.waypoints = []
	    this.element = this.options.element
	    this.createWaypoints()
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoints = function() {
	    var configs = {
	      vertical: [{
	        down: 'enter',
	        up: 'exited',
	        offset: '100%'
	      }, {
	        down: 'entered',
	        up: 'exit',
	        offset: 'bottom-in-view'
	      }, {
	        down: 'exit',
	        up: 'entered',
	        offset: 0
	      }, {
	        down: 'exited',
	        up: 'enter',
	        offset: function() {
	          return -this.adapter.outerHeight()
	        }
	      }],
	      horizontal: [{
	        right: 'enter',
	        left: 'exited',
	        offset: '100%'
	      }, {
	        right: 'entered',
	        left: 'exit',
	        offset: 'right-in-view'
	      }, {
	        right: 'exit',
	        left: 'entered',
	        offset: 0
	      }, {
	        right: 'exited',
	        left: 'enter',
	        offset: function() {
	          return -this.adapter.outerWidth()
	        }
	      }]
	    }
	
	    for (var i = 0, end = configs[this.axis].length; i < end; i++) {
	      var config = configs[this.axis][i]
	      this.createWaypoint(config)
	    }
	  }
	
	  /* Private */
	  Inview.prototype.createWaypoint = function(config) {
	    var self = this
	    this.waypoints.push(new Waypoint({
	      context: this.options.context,
	      element: this.options.element,
	      enabled: this.options.enabled,
	      handler: (function(config) {
	        return function(direction) {
	          self.options[config[direction]].call(self, direction)
	        }
	      }(config)),
	      offset: config.offset,
	      horizontal: this.options.horizontal
	    }))
	  }
	
	  /* Public */
	  Inview.prototype.destroy = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].destroy()
	    }
	    this.waypoints = []
	  }
	
	  Inview.prototype.disable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].disable()
	    }
	  }
	
	  Inview.prototype.enable = function() {
	    for (var i = 0, end = this.waypoints.length; i < end; i++) {
	      this.waypoints[i].enable()
	    }
	  }
	
	  Inview.defaults = {
	    context: window,
	    enabled: true,
	    enter: noop,
	    entered: noop,
	    exit: noop,
	    exited: noop
	  }
	
	  Waypoint.Inview = Inview
	}())
	;

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    isIOS: function isIOS() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
	    },
	    getBodyScrollTop: function getBodyScrollTop() {
	        return self.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop;
	    },
	    getBodyMiddlePos: function getBodyMiddlePos() {
	        return this.getBodyScrollTop() + document.documentElement.clientHeight * 0.5;
	    },
	    //узнать настоящую полную высоту блока с заданным max-height
	    getTrueHeight: function getTrueHeight($block) {
	        var el = $block.clone().css({
	            height: 'auto',
	            width: $block.width(),
	            overflow: 'hidden',
	            'max-height': 'none'
	        }).insertAfter($block);
	
	        var trueHeight = el.outerHeight(true);
	        el.remove();
	
	        return trueHeight;
	    },
	    number_format: __webpack_require__(167),
	
	    setMaskedPhone: function setMaskedPhone($element) {
	        $element.mask('+7(999)999-99-99', { autoclear: false });
	    },
	    setMaskedPhoneCity: function setMaskedPhoneCity($element) {
	        $element.mask('+7(999)999-99-99 (городской)', { autoclear: false });
	    },
	    setMaskedPhoneMobile: function setMaskedPhoneMobile($element) {
	        $element.mask('+7(999)999-99-99 (мобильный)', { autoclear: false });
	    },
	
	    getCookie: function getCookie(name) {
	        var matches = document.cookie.match('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');
	        return matches ? decodeURIComponent(matches[1]) : undefined;
	    },
	
	    setCookie: function setCookie(name, value, options) {
	        options = options || {};
	
	        var expires = options.expires;
	
	        if (typeof expires == 'number' && expires) {
	            var d = new Date();
	            d.setTime(d.getTime() + expires * 1000);
	            expires = options.expires = d;
	        }
	        if (expires && expires.toUTCString) {
	            options.expires = expires.toUTCString();
	        }
	
	        value = encodeURIComponent(value);
	
	        var updatedCookie = name + '=' + value;
	
	        for (var propName in options) {
	            updatedCookie += '; ' + propName;
	            var propValue = options[propName];
	            if (propValue !== true) {
	                updatedCookie += '=' + propValue;
	            }
	        }
	
	        document.cookie = updatedCookie;
	    },
	    deleteCookie: function deleteCookie(name) {
	        var cookie_date = new Date();
	        cookie_date.setTime(cookie_date.getTime() - 1);
	        document.cookie = name += "=; expires=" + cookie_date.toGMTString();
	    }
	};
	var initDadata = function initDadata() {
	    var streetInput = document.getElementById("street");
	    var cityInput = document.getElementById("city").value;
	    var token = 'b574f61916aa7f16b0ed0aaa318da372bfe05254';
	    var type = 'address';
	    var createSuggestions = window.Dadata.createSuggestions;
	
	    var regionSuggestions = createSuggestions(streetInput, {
	        token: token,
	        type: 'address',
	        hint: false,
	        count: 15,
	        params: {
	            from_bound: { value: 'street' },
	            to_bound: { value: 'street' },
	            locations: {
	                city: cityInput
	            },
	            language: 'ru', // Язык результатов
	            strict: true // Строгий поиск по точному совпадению
	        }
	    });
	    var citySuggestions = createSuggestions('', {
	        token: token,
	        type: type,
	        hint: false,
	        params: { from_bound: { value: "city" }, to_bound: { value: "settlement" } }
	    }, regionSuggestions);
	};

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function number_format(number, decimals, decPoint, thousandsSep) {
	  // eslint-disable-line camelcase
	  //  discuss at: https://locutus.io/php/number_format/
	  // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // improved by: davook
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Brett Zamir (https://brett-zamir.me)
	  // improved by: Theriault (https://github.com/Theriault)
	  // improved by: Kevin van Zonneveld (https://kvz.io)
	  // bugfixed by: Michael White (https://getsprink.com)
	  // bugfixed by: Benjamin Lupton
	  // bugfixed by: Allan Jensen (https://www.winternet.no)
	  // bugfixed by: Howard Yeend
	  // bugfixed by: Diogo Resende
	  // bugfixed by: Rival
	  // bugfixed by: Brett Zamir (https://brett-zamir.me)
	  //  revised by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
	  //  revised by: Luke Smith (https://lucassmith.name)
	  //    input by: Kheang Hok Chin (https://www.distantia.ca/)
	  //    input by: Jay Klehr
	  //    input by: Amir Habibi (https://www.residence-mixte.com/)
	  //    input by: Amirouche
	  //   example 1: number_format(1234.56)
	  //   returns 1: '1,235'
	  //   example 2: number_format(1234.56, 2, ',', ' ')
	  //   returns 2: '1 234,56'
	  //   example 3: number_format(1234.5678, 2, '.', '')
	  //   returns 3: '1234.57'
	  //   example 4: number_format(67, 2, ',', '.')
	  //   returns 4: '67,00'
	  //   example 5: number_format(1000)
	  //   returns 5: '1,000'
	  //   example 6: number_format(67.311, 2)
	  //   returns 6: '67.31'
	  //   example 7: number_format(1000.55, 1)
	  //   returns 7: '1,000.6'
	  //   example 8: number_format(67000, 5, ',', '.')
	  //   returns 8: '67.000,00000'
	  //   example 9: number_format(0.9, 0)
	  //   returns 9: '1'
	  //  example 10: number_format('1.20', 2)
	  //  returns 10: '1.20'
	  //  example 11: number_format('1.20', 4)
	  //  returns 11: '1.2000'
	  //  example 12: number_format('1.2000', 3)
	  //  returns 12: '1.200'
	  //  example 13: number_format('1 000,50', 2, '.', ' ')
	  //  returns 13: '100 050.00'
	  //  example 14: number_format(1e-8, 8, '.', '')
	  //  returns 14: '0.00000001'
	
	  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	  var n = !isFinite(+number) ? 0 : +number;
	  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	  var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
	  var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
	  var s = '';
	
	  var toFixedFix = function toFixedFix(n, prec) {
	    if (('' + n).indexOf('e') === -1) {
	      return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
	    } else {
	      var arr = ('' + n).split('e');
	      var sig = '';
	      if (+arr[1] + prec > 0) {
	        sig = '+';
	      }
	      return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
	    }
	  };
	
	  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
	  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
	  if (s[0].length > 3) {
	    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	  }
	  if ((s[1] || '').length < prec) {
	    s[1] = s[1] || '';
	    s[1] += new Array(prec - s[1].length + 1).join('0');
	  }
	
	  return s.join(dec);
	};
	//# sourceMappingURL=number_format.js.map

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var YandexSmartCaptcha = (function () {
	    /*
	    пример контейнера для капчи
	    есть виджет maximaster:widget.yandex.smart.captcha.container
	    <div
	        id="aut_reg_smart_captcha"
	        style="min-width: auto; margin-top: 20px"
	        data-sitekey="ysc1_7Gfc5vSRT9kf7nBgpNatfxUWcZciH0nCpf9gTEidb2202d43"
	        data-widget-id=""
	    ></div>
	    */
	
	    /**
	     * @param elementId - ID контейнера (id="aut_reg_smart_captcha")
	     */
	
	    function YandexSmartCaptcha(elementId) {
	        _classCallCheck(this, YandexSmartCaptcha);
	
	        this.smartCaptcha = window.smartCaptcha || undefined;
	        this.container = $('#' + elementId);
	
	        console.log(elementId);
	    }
	
	    _createClass(YandexSmartCaptcha, [{
	        key: 'init',
	        value: function init() {
	            if (!this.smartCaptcha) {
	                throw new Error('YandexSmartCaptcha error init');
	            }
	
	            var widgetId = this.getWidgetId();
	            if (!widgetId) {
	                console.log('YandexSmartCaptcha: new init');
	
	                if (this.container.length > 0 && this.container[0]) {
	                    widgetId = this.smartCaptcha.render(this.container[0], {
	                        sitekey: this.getSiteKey()
	                    });
	                } else {
	                    console.error('Контейнер капчи не найден:', this.container);
	                }
	                /*let widgetId = this.smartCaptcha.render(this.container[0], {
	                    sitekey: this.getSiteKey()
	                });*/
	
	                this.setWidgetId(widgetId);
	            } else {
	                console.log('YandexSmartCaptcha: reset init');
	                window.smartCaptcha.reset(widgetId);
	            }
	        }
	    }, {
	        key: 'getWidgetId',
	        value: function getWidgetId() {
	            return this.container.attr('data-widget-id');
	        }
	    }, {
	        key: 'setWidgetId',
	        value: function setWidgetId(widgetId) {
	            return this.container.attr('data-widget-id', widgetId);
	        }
	    }, {
	        key: 'getSiteKey',
	        value: function getSiteKey() {
	            return this.container.attr('data-sitekey');
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.container.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.container.show();
	        }
	    }, {
	        key: 'getToken',
	        value: function getToken() {
	            return this.container.find('[name="smart-token"]').val();
	        }
	    }]);
	
	    return YandexSmartCaptcha;
	})();

	exports.YandexSmartCaptcha = YandexSmartCaptcha;

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(301);
	__webpack_require__(302);
	
	var dropFile = __webpack_require__(306);
	var styledSelect = __webpack_require__(309);
	var ratingStars = __webpack_require__(315);
	var functions = __webpack_require__(166);
	
	jQuery(function () {
	    $.prompt.setDefaults({
	        promptspeed: 0,
	        overlayspeed: 300,
	        opacity: 0.5,
	        closeText: 'Закрыть',
	        loaded: function loaded() {
	            var $jqi = $('.jqi');
	            $jqi.addClass('shown');
	        },
	        beforeclose: function beforeclose(e) {
	            var $box = $(e.target);
	            $box.find('.jqi').removeClass('shown');
	        },
	        statechanging: function statechanging() {
	            var $form = $('.jqiform');
	
	            //выключить валидатор, чтоб не глючил в момент переключения состояний
	            $form.off('.validate').removeData('validator').find('.validate-equalTo-blur').off('.validate-equalTo').removeClass('validate-equalTo-blur');
	        },
	        statechanged: function statechanged(event, toStateName) {
	            var $jqi = $('.jqi');
	            var $form = $('.jqiform');
	            var $styledSelects = $jqi.find('.js-styled-select:visible');
	            styledSelect.styleSelects($styledSelects);
	            functions.setMaskedPhone($('.js-masked-phone'));
	
	            if ($form.find('.js-rating-stars').length > 0) {
	                ratingStars.setStars($form.find('.js-rating-stars'));
	            }
	
	            $form.find('.form__input--error').removeClass('form__input--error');
	            $form.find('.form__error-msg').remove();
	
	            if (toStateName == 'regFormStep3_specialist') dropFile.setDropFile($('#diploma-dropfile'));
	
	            if (toStateName == 'regFormStep2_organization') dropFile.setDropFile($('#requisites-dropfile'));
	        },
	        closeDelay: 350,
	        buttons: {}
	    });
	
	    $.prompt.setStateDefaults({
	        buttons: {}
	    });
	});

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			factory(root.jQuery);
		}
	}(this, function($) {
		'use strict';
	
		// ########################################################################
		// Base object
		// ########################################################################
	
		/**
		* Imp - Impromptu object - passing no params will not open, only return the instance
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return Imp - the instance of this Impromptu object
		*/
		var Imp = function(message, options){
			var t = this;
			t.id = Imp.count++;
	
			Imp.lifo.push(t);
	
			if(message){
				t.open(message, options);
			}
			return t;
		};
	
		// ########################################################################
		// static properties and methods
		// ########################################################################
	
		/**
		* defaults - the default options
		*/
		Imp.defaults = {
			prefix:'jqi',
			classes: {
				box: '',
				fade: '',
				prompt: '',
				form: '',
				close: '',
				title: '',
				message: '',
				buttons: '',
				button: '',
				defaultButton: ''
			},
			title: '',
			closeText: '&times;',
			buttons: {
				Ok: true
			},
			buttonTimeout: 1000,
			loaded: function(e){},
			submit: function(e,v,m,f){},
			close: function(e,v,m,f){},
			beforeclose: function(e,v,m,f){},
			statechanging: function(e, from, to){},
			statechanged: function(e, to){},
			opacity: 0.6,
			zIndex: 999,
			overlayspeed: 'slow',
			promptspeed: 'fast',
			show: 'fadeIn',
			hide: 'fadeOut',
			focus: 0,
			defaultButton: 0,
			useiframe: false,
			top: '15%',
			position: {
				container: null,
				x: null,
				y: null,
				arrow: null,
				width: null
			},
			persistent: true,
			timeout: 0,
			closeDelay: 10,
			states: {},
			initialState: 0,
			state: {
				name: null,
				title: '',
				html: '',
				buttons: {
					Ok: true
				},
				focus: 0,
				defaultButton: 0,
				position: {
					container: null,
					x: null,
					y: null,
					arrow: null,
					width: null
				},
				submit: function(e,v,m,f){
					return true;
				}
			}
		};
	
		/**
		* setDefaults - Sets the default options
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setDefaults = function(o) {
			Imp.defaults = $.extend({}, Imp.defaults, o);
		};
	
		/**
		* setStateDefaults - Sets the default options for a state
		* @param o Object - Options to set as defaults
		* @return void
		*/
		Imp.setStateDefaults = function(o) {
			Imp.defaults.state = $.extend({}, Imp.defaults.state, o);
		};
	
		/**
		* @var Int - A counter used to provide a unique ID for new prompts
		*/
		Imp.count = 0;
	
		/**
		* @var Array - An array of Impromptu intances in a LIFO queue (last in first out)
		*/
		Imp.lifo = [];
	
		/**
		* getLast - get the last element from the queue (doesn't pop, just returns)
		* @return Imp - the instance of this Impromptu object or false if queue is empty
		*/
		Imp.getLast = function(){
			var l = Imp.lifo.length;
			return (l > 0)? Imp.lifo[l-1] : false;
		};
	
		/**
		* removeFromStack - remove an element from the lifo stack by its id
		* @param id int - id of the instance to remove
		* @return api - The api of the element removed from the stack or void
		*/
		Imp.removeFromStack = function(id){
			for(var i=Imp.lifo.length-1; i>=0; i--){
				if(Imp.lifo[i].id === id){
					return Imp.lifo.splice(i,1)[0];
				}
			}
		};
	
		// ########################################################################
		// extend our object instance properties and methods
		// ########################################################################
		Imp.prototype = {
	
			/**
			* @var Int - A unique id, simply an autoincremented number
			*/
			id: null,
	
			/**
			* open - Opens the prompt
			* @param message String/Object - String of html or Object of states
			* @param options Object - Options to set the prompt
			* @return Imp - the instance of this Impromptu object
			*/
			open: function(message, options) {
				var t = this;
	
				t.options = $.extend(true,{},Imp.defaults,options);
	
				// Be sure any previous timeouts are destroyed
				if(t.timeout){
					clearTimeout(t.timeout);
				}
				t.timeout = false;
	
				var opts = t.options,
					$body = $(document.body),
					$window = $(window);
	
				//build the box and fade
				var msgbox = '<div class="'+ opts.prefix +'box '+ opts.classes.box +'">';
				if(opts.useiframe && ($('object, applet').length > 0)) {
					msgbox += '<iframe src="javascript:false;" class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></iframe>';
				} else {
					msgbox += '<div class="'+ opts.prefix +'fade '+ opts.classes.fade +'"></div>';
				}
				msgbox += '<div class="'+ opts.prefix +' '+ opts.classes.prompt +'">'+
							'<form action="#" class="'+ opts.prefix +'form '+ opts.classes.form +'">'+
								'<div class="'+ opts.prefix +'close '+ opts.classes.close +'">'+ opts.closeText +'</div>'+
								'<div class="'+ opts.prefix +'states"></div>'+
							'</form>'+
						'</div>'+
					'</div>';
	
				t.jqib = $(msgbox).appendTo($body);
				t.jqi = t.jqib.children('.'+ opts.prefix);
				t.jqif = t.jqib.children('.'+ opts.prefix +'fade');
	
				//if a string was passed, convert to a single state
				if(message.constructor === String){
					message = {
						state0: {
							title: opts.title,
							html: message,
							buttons: opts.buttons,
							position: opts.position,
							focus: opts.focus,
							defaultButton: opts.defaultButton,
							submit: opts.submit
						}
					};
				}
	
				//build the states
				t.options.states = {};
				var k,v;
				for(k in message){
					v = $.extend({},Imp.defaults.state,{name:k},message[k]);
					t.addState(v.name, v);
	
					if(t.currentStateName === ''){
						t.currentStateName = v.name;
					}
				}
	
				//Events
				t.jqi.on('click', '.'+ opts.prefix +'buttons button', function(e){
					var $t = $(this),
						$state = $t.parents('.'+ opts.prefix +'state'),
						statename = $state.data('jqi-name'),
						stateobj = t.options.states[statename],
						msg = $state.children('.'+ opts.prefix +'message'),
						clicked = stateobj.buttons[$t.text()] || stateobj.buttons[$t.html()],
						forminputs = {};
	
					// disable for a moment to prevent multiple clicks
					if(t.options.buttonTimeout > 0){
						t.disableStateButtons(statename);
						setTimeout(function(){
							t.enableStateButtons(statename);
						}, t.options.buttonTimeout);
					}
	
					// if for some reason we couldn't get the value
					if(clicked === undefined){
						for(var i in stateobj.buttons){
							if(stateobj.buttons[i].title === $t.text() || stateobj.buttons[i].title === $t.html()){
								clicked = stateobj.buttons[i].value;
							}
						}
					}
	
					if (clicked === undefined)
					{
						clicked = $t.val();
					}
	
					//collect all form element values from all states.
					$.each(t.jqi.children('form').serializeArray(),function(i,obj){
						if (forminputs[obj.name] === undefined) {
							forminputs[obj.name] = obj.value;
						} else if (typeof forminputs[obj.name] === Array || typeof forminputs[obj.name] === 'object') {
							forminputs[obj.name].push(obj.value);
						} else {
							forminputs[obj.name] = [forminputs[obj.name],obj.value];
						}
					});
	
					// trigger an event
					var promptsubmite = new $.Event('impromptu:submit');
					promptsubmite.stateName = stateobj.name;
					promptsubmite.state = $state;
					$state.trigger(promptsubmite, [clicked, msg, forminputs]);
	
					if(!promptsubmite.isDefaultPrevented()){
						t.close(true, clicked,msg,forminputs);
					}
				});
	
				// if the fade is clicked blink the prompt
				var fadeClicked = function(){
					if(opts.persistent){
						var offset = (opts.top.toString().indexOf('%') >= 0? ($window.height()*(parseInt(opts.top,10)/100)) : parseInt(opts.top,10)),
							top = parseInt(t.jqi.css('top').replace('px',''),10) - offset;
	
						//$window.scrollTop(top);
						$('html,body').animate({ scrollTop: top }, 'fast', function(){
							var i = 0;
							t.jqib.addClass(opts.prefix +'warning');
							var intervalid = setInterval(function(){
								t.jqib.toggleClass(opts.prefix +'warning');
								if(i++ > 1){
									clearInterval(intervalid);
									t.jqib.removeClass(opts.prefix +'warning');
								}
							}, 100);
						});
					}
					else {
						t.close(true);
					}
				};
	
				// listen for esc or tab keys
				var keyDownEventHandler = function(e){
					var key = (window.event) ? event.keyCode : e.keyCode;
	
					//escape key closes
					if(key === 27) {
						fadeClicked();
					}
	
					//enter key pressed trigger the default button if its not on it, ignore if it is a textarea
					if(key === 13){
						var $defBtn = t.getCurrentState().find('.'+ opts.prefix +'defaultbutton');
						var $tgt = $(e.target);
	
						if($tgt.is('textarea,.'+opts.prefix+'button') === false && $defBtn.length > 0){
							e.preventDefault();
							$defBtn.click();
						}
					}
	
					//constrain tabs, tabs should iterate through the state and not leave
					if (key === 9){
						var $inputels = $('input,select,textarea,button',t.getCurrentState());
						var fwd = !e.shiftKey && e.target === $inputels[$inputels.length-1];
						var back = e.shiftKey && e.target === $inputels[0];
						if (fwd || back) {
							setTimeout(function(){
								if (!$inputels){
									return;
								}
								var el = $inputels[back===true ? $inputels.length-1 : 0];
	
								if (el){
									el.focus();
								}
							},10);
							return false;
						}
					}
				};
	
				t.position();
				t.style();
	
				// store copy of the window resize function for interal use only
				t._windowResize = function(e){
					t.position(e);
				};
				$window.resize({ animate: false }, t._windowResize);
	
				t.jqif.click(fadeClicked);
				t.jqi.find('.'+ opts.prefix +'close').click(function(){ t.close(); });
				t.jqi.find('.'+ opts.prefix +'form').submit(function(){ return false; });
				t.jqib.on("keydown",keyDownEventHandler)
							.on('impromptu:loaded', opts.loaded)
							.on('impromptu:beforeclose', opts.beforeclose)
							.on('impromptu:close', opts.close)
							.on('impromptu:statechanging', opts.statechanging)
							.on('impromptu:statechanged', opts.statechanged);
	
				// Show it
				t.jqif[opts.show](opts.overlayspeed);
				t.jqi[opts.show](opts.promptspeed, function(){
	
					t.goToState(
						isNaN(opts.initialState) ? opts.initialState : 
							t.jqi.find('.'+ opts.prefix +'states .'+ opts.prefix +'state').eq(opts.initialState).data('jqi-name')
					);
	
					t.jqib.trigger('impromptu:loaded');
				});
	
				// Timeout
				if(opts.timeout > 0){
					t.timeout = setTimeout(function(){ t.close(true); },opts.timeout);
				}
	
				return t;
			},
	
			/**
			* close - Closes the prompt
			* @param callCallback Function - called when the transition is complete
			* @param clicked String - value of the button clicked (only used internally)
			* @param msg jQuery - The state message body (only used internally)
			* @param formvals Object - key/value pairs of all form field names and values (only used internally)
			* @return Imp - the instance of this Impromptu object
			*/
			close: function(callCallback, clicked, msg, formvals){
				var t = this;
				t.jqib.trigger('impromptu:beforeclose', [clicked,msg,formvals]);
	
				if(t.timeout){
					clearTimeout(t.timeout);
					t.timeout = false;
				}
				Imp.removeFromStack(t.id);
	
				setTimeout(function(){
					if(t.jqib){
	
						t.jqib[t.options.hide](t.options.promptspeed,function(){
	
							t.jqib.trigger('impromptu:close', [clicked,msg,formvals]);
	
							t.jqib.remove();
	
							$(window).off('resize', t._windowResize);
	
							if(typeof callCallback === 'function'){
								callCallback();
							}
						});
					}
	
				}, t.options.closeDelay);
	
				t.currentStateName = "";
				return t;
			},
	
			/**
			* addState - Injects a state into the prompt
			* @param statename String - Name of the state
			* @param stateobj Object - options for the state
			* @param afterState String - selector of the state to insert after
			* @return jQuery - the newly created state
			*/
			addState: function(statename, stateobj, afterState) {
				var t = this,
					state = '',
					$state = null,
					arrow = '',
					title = '',
					opts = t.options,
					pos = $.isFunction(stateobj.position) ? stateobj.position() : stateobj.position,
					$jqistates = t.jqi.find('.'+ opts.prefix +'states'),
					buttons = [],
					showHtml,defbtn,k,v,l,i=0;
	
				stateobj = $.extend({},Imp.defaults.state, {name:statename}, stateobj);
	
				if($.isPlainObject(pos) && pos.arrow !== null){
					arrow = '<div class="'+ opts.prefix + 'arrow '+ opts.prefix + 'arrow'+ pos.arrow +'"></div>';
				}
				if(stateobj.title && stateobj.title !== ''){
					title = '<div class="lead '+ opts.prefix + 'title '+ opts.classes.title +'">'+  stateobj.title +'</div>';
				}
	
				showHtml = stateobj.html;
				if (typeof stateobj.html === 'function') {
					showHtml = 'Error: html function must return text';
				}
	
				state += '<div class="'+ opts.prefix + 'state" data-jqi-name="'+ statename +'">'+
							arrow + title +
							'<div class="'+ opts.prefix +'message '+ opts.classes.message +'">' + showHtml +'</div>'+
							'<div class="'+ opts.prefix +'buttons'+ ($.isEmptyObject(stateobj.buttons)? 'hide ':' ') + opts.classes.buttons +'">';
	
				// state buttons may be in object or array, lets convert objects to arrays
				if($.isArray(stateobj.buttons)){
					buttons = stateobj.buttons;
				}
				else if($.isPlainObject(stateobj.buttons)){
					for(k in stateobj.buttons){
						if(stateobj.buttons.hasOwnProperty(k)){
							buttons.push({ title: k, value: stateobj.buttons[k] });
						}
					}
				}
	
				// iterate over each button and create them
				for(i=0, l=buttons.length; i<l; i++){
					v = buttons[i],
					defbtn = stateobj.focus === i || (isNaN(stateobj.focus) && stateobj.defaultButton === i) ? (opts.prefix + 'defaultbutton ' + opts.classes.defaultButton) : '';
	
					state += '<button class="'+ opts.classes.button +' '+ opts.prefix + 'button '+ defbtn;
	
					if(typeof v.classes !== "undefined"){
						state += ' '+ ($.isArray(v.classes)? v.classes.join(' ') : v.classes) + ' ';
					}
	
					state += '" name="' + opts.prefix + '_' + statename + '_button' + v.title.replace(/[^a-z0-9]+/gi,'') + '" value="' + v.value + '">' + v.title + '</button>';
				}
				
				state += '</div></div>';
	
				$state = $(state).css({display:'none'});
	
				$state.on('impromptu:submit', stateobj.submit);
	
				if(afterState !== undefined){
					t.getState(afterState).after($state);
				}
				else{
					$jqistates.append($state);
				}
	
				t.options.states[statename] = stateobj;
	
				return $state;
			},
	
			/**
			* removeState - Removes a state from the prompt
			* @param state String - Name of the state
			* @param newState String - Name of the state to transition to
			* @return Boolean - returns true on success, false on failure
			*/
			removeState: function(state, newState) {
				var t = this,
					$state = t.getState(state),
					rm = function(){ $state.remove(); };
	
				if($state.length === 0){
					return false;
				}
	
				// transition away from it before deleting
				if($state.css('display') !== 'none'){
					if(newState !== undefined && t.getState(newState).length > 0){
						t.goToState(newState, false, rm);
					}
					else if($state.next().length > 0){
						t.nextState(rm);
					}
					else if($state.prev().length > 0){
						t.prevState(rm);
					}
					else{
						t.close();
					}
				}
				else{
					$state.slideUp('slow', rm);
				}
	
				return true;
			},
	
			/**
			* getApi - Get the api, so you can extract it from $.prompt stack
			* @return jQuery - the prompt
			*/
			getApi: function() {
				return this;
			},
	
			/**
			* getBox - Get the box containing fade and prompt
			* @return jQuery - the prompt
			*/
			getBox: function() {
				return this.jqib;
			},
	
			/**
			* getPrompt - Get the prompt
			* @return jQuery - the prompt
			*/
			getPrompt: function() {
				return this.jqi;
			},
	
			/**
			* getState - Get the state by its name
			* @param statename String - Name of the state
			* @return jQuery - the state
			*/
			getState: function(statename) {
				return this.jqi.find('[data-jqi-name="'+ statename +'"]');
			},
	
			/**
			* getCurrentState - Get the current visible state
			* @return jQuery - the current visible state
			*/
			getCurrentState: function() {
				return this.getState(this.getCurrentStateName());
			},
	
			/**
			* getCurrentStateName - Get the name of the current visible state/substate
			* @return String - the current visible state's name
			*/
			getCurrentStateName: function() {
				return this.currentStateName;
			},
	
			/**
			* disableStateButtons - Disables the buttons in a state
			* @param statename String - Name of the state containing buttons
			* @param buttons Array - Array of button values to disable. By default all are disabled
			* @param enable Boolean - True to enable the buttons instead of disabling (internally use only)
			* @return Void
			*/
			disableStateButtons: function(statename, buttons, enable) {
				var t = this;
	
				if($.isArray(statename)){
					buttons = statename;
					statename = null;
				}
				
				t.getState(statename || t.getCurrentStateName()).find('.'+ t.options.prefix + 'button').each(function(i,btn){
					if(buttons === undefined || $.inArray(btn.value, buttons) !== -1){
						btn.disabled = !enable;
					}
				});
			},
	
			/**
			* enableStateButtons - Enables the buttons in a state
			* @param statename String - Name of the state containing buttons. Defaults to current state
			* @param buttons Array - Array of button values to enable. By default all are enabled
			* @return Void
			*/
			enableStateButtons: function(statename, buttons) {
				this.disableStateButtons(statename, buttons, true);
			},
	
			/**
			* position - Repositions the prompt (Used internally)
			* @return void
			*/
			position: function(e){
				var t = this,
					restoreFx = $.fx.off,
					$state = t.getCurrentState(),
					stateObj = t.options.states[$state.data('jqi-name')],
					pos = stateObj ? $.isFunction(stateObj.position) ? stateObj.position() : stateObj.position : undefined,
					$window = $(window),
					bodyHeight = document.body.scrollHeight, //$(document.body).outerHeight(true),
					windowHeight = $(window).height(),
					documentHeight = $(document).height(),
					height = (bodyHeight > windowHeight) ? bodyHeight : windowHeight,
					scrollTop = parseInt($window.scrollTop(),10),
					top = scrollTop + (t.options.top.toString().indexOf('%') >= 0?
							(windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
				// when resizing the window turn off animation
				if(e !== undefined && e.data.animate === false){
					$.fx.off = true;
				}
	
				t.jqib.css({
					position: "absolute",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
				t.jqif.css({
					position: "fixed",
					height: height,
					width: "100%",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				});
	
				// tour positioning
				if(pos && pos.container){
					var offset = $(pos.container).offset(),
						hasScrolled = false;
						
					if($.isPlainObject(offset) && offset.top !== undefined){
						top = (offset.top + pos.y) - (t.options.top.toString().indexOf('%') >= 0? (windowHeight*(parseInt(t.options.top,10)/100)) : parseInt(t.options.top,10));
	
						t.jqi.css({
							position: "absolute"
						});
						t.jqi.animate({
							top: offset.top + pos.y,
							left: offset.left + pos.x,
							marginLeft: 0,
							width: (pos.width !== undefined)? pos.width : null
						}, function(){
							// if it didn't scroll before, check that the bottom is within view. Since width 
							// is animated we must use the callback before we know the height
							if(!hasScrolled && (offset.top + pos.y + t.jqi.outerHeight(true)) > (scrollTop + windowHeight)){
								$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
								hasScrolled = true;
							}
						});
	
						// scroll if the top is out of the viewing area
						if(top < scrollTop || top > scrollTop + windowHeight){
							$('html,body').animate({ scrollTop: top }, 'slow', 'swing', function(){});
							hasScrolled = true;
						}
					}
				}
				// custom state width animation
				else if(pos && pos.width){
					t.jqi.css({
							position: "absolute",
							left: '50%'
						});
					t.jqi.animate({
							top: pos.y || top,
							left: pos.x || '50%',
							marginLeft: ((pos.width/2)*-1),
							width: pos.width
						});
				}
				// standard prompt positioning
				else{
					t.jqi.css({
						position: "absolute",
						top: top,
						left: '50%',//$window.width()/2,
						marginLeft: ((t.jqi.outerWidth(false)/2)*-1)
					});
				}
	
				// restore fx settings
				if(e !== undefined && e.data.animate === false){
					$.fx.off = restoreFx;
				}
			},
	
			/**
			* style - Restyles the prompt (Used internally)
			* @return void
			*/
			style: function(){
				var t = this;
				
				t.jqif.css({
					zIndex: t.options.zIndex,
					display: "none",
					opacity: t.options.opacity
				});
				t.jqi.css({
					zIndex: t.options.zIndex+1,
					display: "none"
				});
				t.jqib.css({
					zIndex: t.options.zIndex
				});
			},
	
			/**
			* goToState - Goto the specified state
			* @param state String - name of the state to transition to
			* @param subState Boolean - true to be a sub state within the currently open state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			goToState: function(state, subState, callback) {
				var t = this,
					$jqi = t.jqi,
					jqiopts = t.options,
					$state = t.getState(state),
					stateobj = jqiopts.states[$state.data('jqi-name')],
					promptstatechanginge = new $.Event('impromptu:statechanging'),
					opts = t.options;
	
				if(stateobj !== undefined){
	
	
					if (typeof stateobj.html === 'function') {
						var contentLaterFunc = stateobj.html;
						$state.find('.' + opts.prefix +'message ').html(contentLaterFunc());
					}
	
					// subState can be ommitted
					if(typeof subState === 'function'){
						callback = subState;
						subState = false;
					}
	
					t.jqib.trigger(promptstatechanginge, [t.getCurrentStateName(), state]);
	
					if(!promptstatechanginge.isDefaultPrevented() && $state.length > 0){
						t.jqi.find('.'+ opts.prefix +'parentstate').removeClass(opts.prefix +'parentstate');
	
						if(subState){ // hide any open substates
							// get rid of any substates
							t.jqi.find('.'+ opts.prefix +'substate').not($state)
								.slideUp(jqiopts.promptspeed)
								.removeClass('.'+ opts.prefix +'substate')
								.find('.'+ opts.prefix +'arrow').hide();
	
							// add parent state class so it can be visible, but blocked
							t.jqi.find('.'+ opts.prefix +'state:visible').addClass(opts.prefix +'parentstate');
	
							// add substate class so we know it will be smaller
							$state.addClass(opts.prefix +'substate');
						}
						else{ // hide any open states
							t.jqi.find('.'+ opts.prefix +'state').not($state)
								.slideUp(jqiopts.promptspeed)
								.find('.'+ opts.prefix +'arrow').hide();
						}
						t.currentStateName = stateobj.name;
	
						$state.slideDown(jqiopts.promptspeed,function(){
							var $t = $(this);
							t.enableStateButtons();
							
							// if focus is a selector, find it, else its button index
							if(typeof(stateobj.focus) === 'string'){
								$t.find(stateobj.focus).eq(0).focus();
							}
							else{
								$t.find('.'+ opts.prefix +'defaultbutton').focus();
							}
	
							$t.find('.'+ opts.prefix +'arrow').show(jqiopts.promptspeed);
	
							if (typeof callback === 'function'){
								t.jqib.on('impromptu:statechanged', callback);
							}
							t.jqib.trigger('impromptu:statechanged', [state]);
							if (typeof callback === 'function'){
								t.jqib.off('impromptu:statechanged', callback);
							}
						});
						if(!subState){
							t.position();
						}
					} // end isDefaultPrevented()	
				}// end stateobj !== undefined
	
				return $state;
			},
	
			/**
			* nextState - Transition to the next state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			nextState: function(callback) {
				var t = this,
					$next = t.getCurrentState().next();
				if($next.length > 0){
					t.goToState( $next.data('jqi-name'), callback );
				}
				return $next;
			},
	
			/**
			* prevState - Transition to the previous state
			* @param callback Function - called when the transition is complete
			* @return jQuery - the newly active state
			*/
			prevState: function(callback) {
				var t = this,
					$prev = t.getCurrentState().prev();
				if($prev.length > 0){
					t.goToState( $prev.data('jqi-name'), callback );
				}
				return $prev;
			}
	
		};
	
		// ########################################################################
		// $.prompt will manage a queue of Impromptu instances
		// ########################################################################
	
		/**
		* $.prompt create a new Impromptu instance and push it on the stack of instances
		* @param message String/Object - String of html or Object of states
		* @param options Object - Options to set the prompt
		* @return jQuery - the jQuery object of the prompt within the modal
		*/
		$.prompt = function(message, options){
			var api = new Imp(message, options);
			return api.jqi;
		};
	
		/**
		* Copy over static methods
		*/
		$.each(Imp, function(k,v){
			$.prompt[k] = v;
		});
	
		/**
		* Create a proxy for accessing all instance methods. The close method pops from queue.
		*/
		$.each(Imp.prototype, function(k,v){
			$.prompt[k] = function(){
				var api = Imp.getLast(); // always use the last instance on the stack
	
				if(api && typeof api[k] === "function"){
					return api[k].apply(api, arguments);
				}
			};
		});
	
		// ########################################################################
		// jQuery Plugin and public access
		// ########################################################################
	
		/**
		* Enable using $('.selector').prompt({});
		* This will grab the html within the prompt as the prompt message
		*/
		$.fn.prompt = function(options){
			if(options === undefined){
				options = {};
			}
			if(options.withDataAndEvents === undefined){
				options.withDataAndEvents = false;
			}
	
			$.prompt($(this).clone(options.withDataAndEvents).html(),options);
		};
	
		/**
		* Export it as Impromptu and $.prompt
		* Can be used from here forth as new Impromptu(states, opts)
		*/
		window.Impromptu = Imp;
	
	}));


/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(307);
	
	// reference: https://css-tricks.com/drag-and-drop-file-uploading/
	
	jQuery(function () {
	    // feature detection for drag&drop upload
	    var isAdvancedUpload = (function () {
	        var div = document.createElement('div');
	        return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
	    })();
	
	    module.exports.setDropFile = function ($dropContainer) {
	        // applying the effect for every form
	        $dropContainer.each(function () {
	            var $this = $(this),
	                $input = $this.find('input[type="file"]'),
	                $textContainer = $this.find('.drop-file__text'),
	
	            //$errorMsg	 = $this.find( '.box__error span' ),
	            droppedFiles = false,
	                showFiles = function showFiles(files) {
	                var $fileName = $textContainer.find('.drop-file__filename');
	                if ($fileName.length == 0) {
	                    $textContainer.append('<div class="drop-file__filename" />');
	                    $fileName = $textContainer.find('.drop-file__filename');
	                }
	
	                $fileName.text(files.length > 1 ? ($input.attr('data-multiple-caption') || '').replace('{count}', files.length) : files[0].name);
	            };
	
	            // letting the server side to know we are going to make an Ajax request
	            //$this.append( '<input type="hidden" name="ajax" value="1" />' );
	
	            // automatically submit the form on file select
	            $input.on('change', function (e) {
	                showFiles(e.target.files);
	            });
	
	            // drag&drop files if the feature is available
	            if (isAdvancedUpload) {
	                $this.addClass('has-advanced-upload') // letting the CSS part to know drag&drop is supported by the browser
	                .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
	                    // preventing the unwanted behaviours
	                    e.preventDefault();
	                    e.stopPropagation();
	                }).on('dragover dragenter', function () //
	                {
	                    $this.addClass('is-dragover');
	                }).on('dragleave dragend drop', function () {
	                    $this.removeClass('is-dragover');
	                }).on('drop', function (e) {
	                    droppedFiles = e.originalEvent.dataTransfer.files; // the files that were dropped
	                    showFiles(droppedFiles);
	                });
	            }
	        });
	    };
	});

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(310);
	__webpack_require__(312);
	
	var styleSelects = function styleSelects($select) {
	    var overwriteOption = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    $select.each(function () {
	        var $this = $(this);
	
	        var options = {
	            language: 'ru',
	            minimumResultsForSearch: Infinity,
	            dropdownParent: $this.parent()
	        };
	
	        if (!$.isEmptyObject(overwriteOption)) {
	            options = overwriteOption;
	            options.dropdownParent = $this.parent();
	        }
	
	        $this.select2(options).on('select2:open', function () {
	            var $options = $this.parent().find('.select2-container--default .select2-results > .select2-results__options');
	
	            $options.mCustomScrollbar('destroy');
	            $options.mCustomScrollbar('update');
	
	            setTimeout(function () {
	                $options.mCustomScrollbar({
	                    axis: 'y',
	                    scrollbarPosition: 'inside',
	                    advanced: {
	                        updateOnContentResize: true
	                    },
	                    live: true
	                });
	            }, 0);
	        });
	    });
	};
	
	module.exports.styleSelects = styleSelects;

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(313);

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(316);
	
	jQuery(function () {
	    var setStars = function setStars($ratingStars) {
	        if ($ratingStars == undefined) $ratingStars = $('.js-rating-stars');
	
	        var $elementRate = $ratingStars.find('.rating-stars__star-yellow');
	        var curSelectedValElementRate = $elementRate.filter('.rating-stars__star-yellow--filled').length;
	
	        $ratingStars.each(function () {
	            var $this = $ratingStars;
	            var $stars = $this.find('.rating-stars__star');
	            var $input = $this.find('.rating-stars__hidden-value');
	
	            var curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	            if (curSelectedVal >= 1) curSelectedVal -= 1;
	
	            $stars.hover(function () {
	                var $curStar = $(this);
	                $stars.removeClass('rating-stars__star--filled');
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--hover');
	            }, function () {
	                $stars.removeClass('rating-stars__star--hover');
	                $stars.slice(0, curSelectedVal).addClass('rating-stars__star--filled');
	            });
	
	            $stars.click(function () {
	                var $curStar = $(this);
	                $curStar.prevAll('.rating-stars__star').andSelf().addClass('rating-stars__star--filled');
	
	                curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	                $input.val(curSelectedVal);
	            });
	
	            if (curSelectedValElementRate >= 1) curSelectedValElementRate -= 1;
	
	            $elementRate.hover(function () {
	                var $curStar = $(this);
	                $elementRate.removeClass('rating-stars__star-yellow--filled');
	                $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--hover');
	            }, function () {
	                $elementRate.removeClass('rating-stars__star-yellow--hover');
	                $elementRate.slice(0, curSelectedValElementRate).addClass('rating-stars__star-yellow--filled');
	            });
	        });
	    };
	
	    setStars();
	
	    module.exports.setStars = setStars;
	});
	
	/* При клике на звездочку устаналиваем оценку для элемента */
	$('.js-rating-stars').find('.rating-stars__star-yellow').one('click', function () {
	    var $curStar = $(this);
	    $curStar.prevAll('.rating-stars__star-yellow').andSelf().addClass('rating-stars__star-yellow--filled');
	    $.ajax({
	        url: '/ajax/action/element_rate/add/',
	        data: 'rating=' + $('.js-rating-stars').find('.rating-stars__star-yellow').filter('.rating-stars__star-yellow--filled').length + '&element_id=' + $('input[name="rate_element_id"]').val() + '&entity_id=' + $('input[name="rate_entity_id"]').val(),
	        success: function success() {
	            $.ajax({
	                url: '/ajax/component/maximaster:element.rate/element/',
	                data: 'ENTITY_ID=' + $('input[name="rate_entity_id"]').val() + '&ELEMENT_ID=' + $('input[name="rate_element_id"]').val(),
	                success: function success(result) {
	                    $('.product-card__element_rate-container').html(result.html);
	                }
	            });
	        }
	    });
	});
	
	/* Вызываем окно авторизации, если кликает не авторизированный пользователь */
	$(document).on('click', '.js-rating-show-auth', function () {
	    if (!$('.jqi').hasClass('shown')) {
	        $('.js-jqi-show-login').trigger('click');
	    }
	});

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(319);
	var functions = __webpack_require__(166);
	
	jQuery(function () {
	    module.exports.formValidateDefaults = {
	        errorPlacement: function errorPlacement(error, element) {
	            element.addClass('form__input--error');
	            element.removeClass('form__input--correct');
	            var $elParent = element.parent();
	            $elParent.removeClass('icon-field--correct');
	            error.addClass('form__error-msg');
	
	            if (element.attr('type') == 'checkbox' || element.attr('type') == 'radio' || element.attr('type') == 'file') {
	                var $formField = element.closest('.form__field');
	                var $headlabel = $formField.find('.prompt__head-label').first();
	                error.addClass('form__error-msg--custom');
	
	                if ($headlabel.length > 0) {
	                    error.insertAfter($headlabel);
	                } else {
	                    $formField.prepend(error);
	                }
	            } else {
	                error.insertBefore($elParent);
	            }
	        },
	        focusInvalid: false,
	        onkeyup: false,
	        success: function success(label, element) {
	            label.remove();
	            var $el = $(element).removeClass('form__input--error');
	            $el.addClass('form__input--correct');
	            var $elParent = $el.parent();
	            $elParent.addClass('icon-field--correct');
	        },
	        errorElement: 'div',
	        onclick: false
	    };
	
	    functions.setMaskedPhone($('.js-masked-phone'));
	    functions.setMaskedPhoneCity($('.js-masked-phone-city'));
	    functions.setMaskedPhoneMobile($('.js-masked-phone-mobile'));
	});

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _trackerTracker = __webpack_require__(140);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	var _modulesYandexSmartCaptchaYandexSmartCaptcha = __webpack_require__(299);
	
	__webpack_require__(534);
	__webpack_require__(300);
	
	var form = __webpack_require__(318);
	
	jQuery(function () {
	    $(document).on('click', '.js-add-question-shop', function (e) {
	        e.preventDefault();
	        $.ajax({
	            url: '/ajax/action/shop_questions/showAddForm/',
	            success: function success(result) {
	                var trackers = new _trackerTracker2['default']();
	                trackers.onPMbtnFAQ();
	
	                addQuestionPrompt.addQuestion.html = result.html;
	                $.prompt(addQuestionPrompt);
	                new _modulesYandexSmartCaptchaYandexSmartCaptcha.YandexSmartCaptcha('detail_element_add_question_captcha').init();
	            }
	        });
	    });
	
	    var addQuestionPrompt = {
	        addQuestion: {
	            submit: function submit(e, v, m) {
	                e.preventDefault();
	                var $this = $(this);
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        question_name: { required: true },
	                        question_email: { required: true, email: true },
	                        question_phone: { required: true, phoneMask: true },
	                        question_city: { required: true },
	                        question_activity: { required: true }
	                    },
	                    messages: {
	                        question_name: { required: 'Не указано имя' },
	                        question_city: { required: 'Не указан город' },
	                        question_activity: {
	                            required: 'Не указан род деятельности'
	                        },
	                        question_email: {
	                            required: $.validator.messages.EMAIL.required,
	                            email: $.validator.messages.EMAIL.email
	                        },
	                        question_phone: {
	                            required: $.validator.messages.PHONE.required,
	                            phoneMask: $.validator.messages.PHONE.phoneMask
	                        }
	                    },
	                    submitHandler: function submitHandler() {
	                        $.ajax({
	                            type: 'POST',
	                            url: '/ajax/action/shop_questions/add/',
	                            data: $('form.jqiform').serializeArray(),
	                            success: function success(result) {
	                                console.log(result);
	                                if (result.code === 200) {
	                                    $.prompt.getState('addQuestion').find('.form').html('<p>' + result.html + '</p>');
	
	                                    var trackers = new _trackerTracker2['default']();
	                                    trackers.onPMfrmFAQ();
	                                } else {
	                                    var errorDiv = $('<div/>', {
	                                        'class': 'error form__error-msg',
	                                        text: result.data.error
	                                    });
	                                    $this.find('.form__head-label').after(errorDiv);
	                                }
	                            }
	                        });
	                        //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
	                        // чтобы не казалось, будто он совсем пропал с экрана
	                        $.prompt.position();
	                    }
	                });
	                var $form = m.closest('form');
	                $form.validate($params);
	            }
	        }
	    };
	});

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/faq.49735cebec62942e829a.js